import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

interface IOverlayProps {
  color?: string;
}

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: ${colors.white};
`;

export const MainWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  overflow-y: hidden;
  overflow-x: scroll;
`;

export const SideContainer = styled.div`
  display: flex;
  width: 416px;
  min-width: 416px;
  height: 100%;
  flex-direction: column;
  position: relative;
`;

export const LeftSection = styled(SideContainer)`
  background-color: ${colors.grey1};
`;

export const MiddleContainer = styled.div`
  flex-grow: 1;
  flex-direction: row;
  height: 100%;
  background-color: ${colors.white};
  min-width: 420px;
`;

export const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
`;

export const ScrollWrapper = styled.div`
  overflow: scroll;
  height: 100%;
  z-index: 1;
`;

export const OverlayContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
`;

export const Overlay = styled.div<IOverlayProps>`
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: white;
  opacity: 0.8;
  z-index: 2;

  ${({ color }) => color && `background-color: ${color};`}
`;

export const NavigationPromptWrapper = styled.div`
  height: 0;
`;
